var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3000,
    height: 2000,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 3000 2000",
    style: {
      zIndex: 1,
      marginRight: "-2px",
      display: "block",
      animationPlayState: "running"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1500,1000) scale(1,1) translate(-1500,-1000)",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 0)",
      animationPlayState: "running"
    }
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    style: {
      animationPlayState: "running"
    }
  }, "@keyframes ld-speed-dash {\n    0% { transform: translate(0,-3710.5512754639894px); }\n    100% { transform: translate(0,3710.5512754639894px); }\n  }\n  .ld.ld-speed-dash {\n    animation: ld-speed-dash 10s linear infinite;\n  }"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1500,1000)",
    style: {
      transform: "matrix(1, 0, 0, 1, 1500, 1000)",
      animationPlayState: "running"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "matrix(0.707107, 0.707107, -0.707107, 0.707107, 0, 0)",
      animationPlayState: "running"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 378.1913958670402,
    x2: 378.1913958670402,
    y1: 0,
    y2: -79.46337061858222,
    stroke: "#712be2",
    strokeWidth: 0.7407713995509047,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1278.87)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-3.27671s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1019.4503113057644,
    x2: -1019.4503113057644,
    y1: 0,
    y2: -90.82586717215179,
    stroke: "#b464be",
    strokeWidth: 2.174957119317286,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 1971.33)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-3.82819s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1026.220237144098,
    x2: -1026.220237144098,
    y1: 0,
    y2: -60.18875832467365,
    stroke: "#712be2",
    strokeWidth: 1.6477305331109127,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2248.65)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-1.96992s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -144.35111929172305,
    x2: -144.35111929172305,
    y1: 0,
    y2: -71.64258472735577,
    stroke: "#712be2",
    strokeWidth: 3.1501343025984196,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -424.161)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-4.42844s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 703.2643435107626,
    x2: 703.2643435107626,
    y1: 0,
    y2: -93.99004540794802,
    stroke: "#b464be",
    strokeWidth: 4.492036410578333,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2770.42)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-8.73317s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -875.2575671582492,
    x2: -875.2575671582492,
    y1: 0,
    y2: -72.01163308061095,
    stroke: "#712be2",
    strokeWidth: 1.986623927065574,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -3626.8)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-5.05643s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -984.2955960484235,
    x2: -984.2955960484235,
    y1: 0,
    y2: -48.99609864486657,
    stroke: "#b464be",
    strokeWidth: 1.5797735662355183,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -605.74)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-4.18376s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1453.4796155831907,
    x2: 1453.4796155831907,
    y1: 0,
    y2: -68.61068503397308,
    stroke: "#b464be",
    strokeWidth: 2.5553852252139473,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 1911.56)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-7.57584s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1476.9829727680356,
    x2: 1476.9829727680356,
    y1: 0,
    y2: -91.86572780775765,
    stroke: "#712be2",
    strokeWidth: 2.829196895408815,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1821.27)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-2.54582s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -336.2363188627342,
    x2: -336.2363188627342,
    y1: 0,
    y2: -76.35897182125109,
    stroke: "#712be2",
    strokeWidth: 0.715424925607,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 51.6954)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-5.06966s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1284.490782850969,
    x2: -1284.490782850969,
    y1: 0,
    y2: -81.03575777686886,
    stroke: "#b464be",
    strokeWidth: 1.1338272838970909,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1078.53)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-3.54667s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 782.7855267468831,
    x2: 782.7855267468831,
    y1: 0,
    y2: -80.75352236903304,
    stroke: "#712be2",
    strokeWidth: 2.2970462460466754,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -32.5044)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-2.4781s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1257.823282338629,
    x2: -1257.823282338629,
    y1: 0,
    y2: -41.75110654989775,
    stroke: "#712be2",
    strokeWidth: 2.463598406364672,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -3116.57)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-5.4002s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -552.1492440086313,
    x2: -552.1492440086313,
    y1: 0,
    y2: -94.505857976046,
    stroke: "#b464be",
    strokeWidth: 1.0208140139757194,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2074.25)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-7.79507s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -234.20448665526615,
    x2: -234.20448665526615,
    y1: 0,
    y2: -62.5100664653739,
    stroke: "#b464be",
    strokeWidth: 2.03139091599819,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2635.49)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-8.55134s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -288.44542891165406,
    x2: -288.44542891165406,
    y1: 0,
    y2: -84.8175093773605,
    stroke: "#b464be",
    strokeWidth: 2.012178142258497,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 607.054)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-5.81801s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1464.3155268655885,
    x2: -1464.3155268655885,
    y1: 0,
    y2: -88.32977212734903,
    stroke: "#712be2",
    strokeWidth: 2.4071334283187564,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2774.96)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-0.63036s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -247.41616510454634,
    x2: -247.41616510454634,
    y1: 0,
    y2: -59.42892212815258,
    stroke: "#712be2",
    strokeWidth: 1.405986122380909,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1968.08)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-2.34799s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1300.7886519264505,
    x2: -1300.7886519264505,
    y1: 0,
    y2: -104.25892693939174,
    stroke: "#712be2",
    strokeWidth: 3.49628053261434,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2982.6)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-9.01908s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1320.863161623903,
    x2: -1320.863161623903,
    y1: 0,
    y2: -66.8372266439051,
    stroke: "#b464be",
    strokeWidth: 0.0564077126085849,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2618.77)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-5.73559s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -769.6852623606869,
    x2: -769.6852623606869,
    y1: 0,
    y2: -30.546139414756468,
    stroke: "#712be2",
    strokeWidth: 4.31148999184477,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 1857.58)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-7.5031s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.6862572440455,
    x2: 132.6862572440455,
    y1: 0,
    y2: -102.36818863850331,
    stroke: "#712be2",
    strokeWidth: 1.7859310823261443,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2733.41)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-8.6833s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1016.4505228263638,
    x2: 1016.4505228263638,
    y1: 0,
    y2: -62.65144598103964,
    stroke: "#712be2",
    strokeWidth: 1.033509017890759,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 43.9329)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-7.5296s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 577.3477176502096,
    x2: 577.3477176502096,
    y1: 0,
    y2: -103.50185480244983,
    stroke: "#b464be",
    strokeWidth: 0.9670135242441769,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 977.419)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-8.15854s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -330.4109462426632,
    x2: -330.4109462426632,
    y1: 0,
    y2: -33.20217049084206,
    stroke: "#b464be",
    strokeWidth: 0.8627821622629517,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2312.52)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-9.05807s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -16.634241154570574,
    x2: -16.634241154570574,
    y1: 0,
    y2: -44.7655858831868,
    stroke: "#b464be",
    strokeWidth: 1.8259180000885578,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 369.059)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-5.49731s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350.9352281064053,
    x2: 350.9352281064053,
    y1: 0,
    y2: -63.71131788019689,
    stroke: "#b464be",
    strokeWidth: 0.6983219392926865,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 1597.02)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-7.152s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1351.1578214422314,
    x2: -1351.1578214422314,
    y1: 0,
    y2: -37.7362451052716,
    stroke: "#712be2",
    strokeWidth: 1.2658836460804923,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2824.42)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-8.80593s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 770.4529363114254,
    x2: 770.4529363114254,
    y1: 0,
    y2: -76.94264247488493,
    stroke: "#712be2",
    strokeWidth: 2.15701822182036,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 121.35)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-7.58176s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -706.7121426904092,
    x2: -706.7121426904092,
    y1: 0,
    y2: -100.5730419115299,
    stroke: "#712be2",
    strokeWidth: 3.607417372708875,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2295.38)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-4.04652s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1189.7949768173758,
    x2: -1189.7949768173758,
    y1: 0,
    y2: -38.65717272973527,
    stroke: "#712be2",
    strokeWidth: 0.923131799135295,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 3598.91)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-4.92478s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1133.6260425080425,
    x2: 1133.6260425080425,
    y1: 0,
    y2: -79.7302625934353,
    stroke: "#712be2",
    strokeWidth: 1.8330437430331037,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1193.45)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-3.39182s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.47721138821815,
    x2: 56.47721138821815,
    y1: 0,
    y2: -96.05735786587792,
    stroke: "#712be2",
    strokeWidth: 2.3711825087928204,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2382.96)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-5.89447s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -469.8057696284106,
    x2: -469.8057696284106,
    y1: 0,
    y2: -71.21614976045927,
    stroke: "#b464be",
    strokeWidth: 1.6629246212319415,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2848.01)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-9.41886s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1419.3603781677198,
    x2: -1419.3603781677198,
    y1: 0,
    y2: -87.22404693655696,
    stroke: "#b464be",
    strokeWidth: 4.276547504771636,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 1938.15)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-7.61167s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -677.5686622797779,
    x2: -677.5686622797779,
    y1: 0,
    y2: -42.344108984816074,
    stroke: "#b464be",
    strokeWidth: 0.7198281791978733,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2868.29)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-1.13495s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -261.57321992853014,
    x2: -261.57321992853014,
    y1: 0,
    y2: -85.05356684272445,
    stroke: "#712be2",
    strokeWidth: 1.0745596263159063,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 875.467)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-3.08985s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -57.189093008997325,
    x2: -57.189093008997325,
    y1: 0,
    y2: -91.43438371282981,
    stroke: "#712be2",
    strokeWidth: 0.6887409322337912,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 3050.28)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-4.55514s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -997.6989128513636,
    x2: -997.6989128513636,
    y1: 0,
    y2: -70.22525839710406,
    stroke: "#712be2",
    strokeWidth: 1.1962244628991048,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 1380.35)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-6.86004s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 586.6507011918989,
    x2: 586.6507011918989,
    y1: 0,
    y2: -43.64567902183417,
    stroke: "#b464be",
    strokeWidth: 3.3251090129739036,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2861.73)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-1.1438s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -773.0713590232425,
    x2: -773.0713590232425,
    y1: 0,
    y2: -43.558726897588315,
    stroke: "#712be2",
    strokeWidth: 1.2052352306408731,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 3147.94)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-4.62094s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1319.0008646013378,
    x2: 1319.0008646013378,
    y1: 0,
    y2: -63.86970368029556,
    stroke: "#b464be",
    strokeWidth: 2.5295382798380475,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2082.49)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-6.09691s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1454.708453281537,
    x2: 1454.708453281537,
    y1: 0,
    y2: -48.081868726535035,
    stroke: "#b464be",
    strokeWidth: 1.5390923976512438,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 666.022)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-5.89747s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1433.3208208389403,
    x2: 1433.3208208389403,
    y1: 0,
    y2: -96.80547528370342,
    stroke: "#b464be",
    strokeWidth: 2.6053462065110344,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1844.26)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-1.25742s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -351.04778981917394,
    x2: -351.04778981917394,
    y1: 0,
    y2: -31.49862595831357,
    stroke: "#712be2",
    strokeWidth: 1.3990128802077106,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 174.314)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-5.23489s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -140.53027603172885,
    x2: -140.53027603172885,
    y1: 0,
    y2: -53.86785303459271,
    stroke: "#b464be",
    strokeWidth: 0.6343072769590663,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2630.97)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-4.27263s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -101.2848778861497,
    x2: -101.2848778861497,
    y1: 0,
    y2: -95.9869277297536,
    stroke: "#b464be",
    strokeWidth: 4.882600567310353,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1053.47)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-6.79022s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1096.3813986341675,
    x2: 1096.3813986341675,
    y1: 0,
    y2: -45.19299659872742,
    stroke: "#712be2",
    strokeWidth: 4.947809621286291,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -312.978)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-2.28913s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.32628143367708,
    x2: 238.32628143367708,
    y1: 0,
    y2: -54.42118435723653,
    stroke: "#b464be",
    strokeWidth: 4.4164586930385745,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 904.202)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-6.21842s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 502.8220557187306,
    x2: 502.8220557187306,
    y1: 0,
    y2: -31.68463661163525,
    stroke: "#712be2",
    strokeWidth: 1.3384961608962698,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -427.033)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-4.42457s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1243.5949364873104,
    x2: 1243.5949364873104,
    y1: 0,
    y2: -58.012158388129805,
    stroke: "#b464be",
    strokeWidth: 0.7104549228422352,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -87.5096)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-4.88208s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1362.0447109345832,
    x2: 1362.0447109345832,
    y1: 0,
    y2: -49.18929684724553,
    stroke: "#712be2",
    strokeWidth: 3.0622572674137363,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2074.55)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-7.79547s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -381.7335613045354,
    x2: -381.7335613045354,
    y1: 0,
    y2: -58.360980816435756,
    stroke: "#712be2",
    strokeWidth: 1.9330009011442784,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -3319.3)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-5.26361s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.47487321932869,
    x2: 228.47487321932869,
    y1: 0,
    y2: -91.88165634488848,
    stroke: "#b464be",
    strokeWidth: 0.21686333082700737,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 1364.64)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-6.83887s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760.1002884106169,
    x2: 760.1002884106169,
    y1: 0,
    y2: -94.9930087621246,
    stroke: "#712be2",
    strokeWidth: 1.2473004515362807,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 3248.51)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-4.6887s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1278.40707765308,
    x2: 1278.40707765308,
    y1: 0,
    y2: -102.6380898566833,
    stroke: "#b464be",
    strokeWidth: 4.251120545226281,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 3532.27)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-9.75976s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1477.6420117505916,
    x2: -1477.6420117505916,
    y1: 0,
    y2: -72.17631125316919,
    stroke: "#712be2",
    strokeWidth: 2.1362798742365365,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -528.902)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-2.14365s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1491.6980970934871,
    x2: 1491.6980970934871,
    y1: 0,
    y2: -72.41057023490669,
    stroke: "#b464be",
    strokeWidth: 1.5532768519132445,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -3530.81)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-0.242202s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1416.6004048489017,
    x2: 1416.6004048489017,
    y1: 0,
    y2: -98.61697882519302,
    stroke: "#712be2",
    strokeWidth: 2.0132598042283067,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 677.569)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-5.91303s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11.310944665066325,
    x2: -11.310944665066325,
    y1: 0,
    y2: -94.36609312294692,
    stroke: "#712be2",
    strokeWidth: 4.95785674412073,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -595.558)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-2.09874s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.1090158966905,
    x2: 611.1090158966905,
    y1: 0,
    y2: -63.68270839956153,
    stroke: "#712be2",
    strokeWidth: 4.209462444665646,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1112.36)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-1.75054s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 803.3543171511117,
    x2: 803.3543171511117,
    y1: 0,
    y2: -83.30023685487913,
    stroke: "#b464be",
    strokeWidth: 2.404420400207501,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1626.16)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-6.40437s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1313.5019987893086,
    x2: 1313.5019987893086,
    y1: 0,
    y2: -64.96340452591559,
    stroke: "#b464be",
    strokeWidth: 1.3518749234716665,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -3230.29)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-0.647162s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1458.1582146527196,
    x2: 1458.1582146527196,
    y1: 0,
    y2: -70.77732915608814,
    stroke: "#b464be",
    strokeWidth: 4.830656945909384,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 3626.08)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-9.94309s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -970.9946317252169,
    x2: -970.9946317252169,
    y1: 0,
    y2: -31.514320836322902,
    stroke: "#b464be",
    strokeWidth: 3.8165193316718584,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -529.407)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-7.14331s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -106.29635874445387,
    x2: -106.29635874445387,
    y1: 0,
    y2: -84.91842799477257,
    stroke: "#b464be",
    strokeWidth: 4.727707653282613,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 548.709)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-5.73939s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.5094063208548,
    x2: 442.5094063208548,
    y1: 0,
    y2: -89.89795444642641,
    stroke: "#b464be",
    strokeWidth: 4.478197426014656,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2249.31)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-4.01548s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1051.7669903115254,
    x2: -1051.7669903115254,
    y1: 0,
    y2: -63.162135678184576,
    stroke: "#712be2",
    strokeWidth: 4.285739987102987,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2133.25)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-2.12543s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.18612822278226,
    x2: 207.18612822278226,
    y1: 0,
    y2: -43.324452217370805,
    stroke: "#712be2",
    strokeWidth: 1.4629745255135485,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2930.56)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-1.05104s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1402.6743246431647,
    x2: 1402.6743246431647,
    y1: 0,
    y2: -87.3716574367806,
    stroke: "#712be2",
    strokeWidth: 1.572586532873398,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1356.47)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-3.17215s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.5941301453385,
    x2: 506.5941301453385,
    y1: 0,
    y2: -88.76080808861445,
    stroke: "#712be2",
    strokeWidth: 2.147154245215648,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 3123.3)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-4.60434s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 901.2333421156984,
    x2: 901.2333421156984,
    y1: 0,
    y2: -72.19667015710837,
    stroke: "#712be2",
    strokeWidth: 0.392559340605545,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -106.849)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-4.85602s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.38754050601693,
    x2: 355.38754050601693,
    y1: 0,
    y2: -72.6020841806504,
    stroke: "#712be2",
    strokeWidth: 0.018786228756098033,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2070.1)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-6.10526s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -985.876659225221,
    x2: -985.876659225221,
    y1: 0,
    y2: -52.14185648638846,
    stroke: "#712be2",
    strokeWidth: 0.5958834262722135,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -3675.21)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-0.0476251s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1339.5010273030164,
    x2: 1339.5010273030164,
    y1: 0,
    y2: -53.962754031757,
    stroke: "#712be2",
    strokeWidth: 3.4545231315888794,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1191.46)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-6.69725s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.83837807882696,
    x2: 410.83837807882696,
    y1: 0,
    y2: -82.17277708674465,
    stroke: "#b464be",
    strokeWidth: 0.4641062180647537,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 3545.74)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-9.88896s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1125.8679653549618,
    x2: -1125.8679653549618,
    y1: 0,
    y2: -95.76372486194239,
    stroke: "#712be2",
    strokeWidth: 1.5024171477872061,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 413.637)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-7.77869s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -702.0451667171484,
    x2: -702.0451667171484,
    y1: 0,
    y2: -44.273312057086585,
    stroke: "#b464be",
    strokeWidth: 2.082023094907565,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -3141.59)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-0.766674s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 790.0235316176713,
    x2: 790.0235316176713,
    y1: 0,
    y2: -99.40852596371963,
    stroke: "#b464be",
    strokeWidth: 1.720912138953662,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 458.966)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-5.61846s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.8671406596363,
    x2: 450.8671406596363,
    y1: 0,
    y2: -99.75175567283792,
    stroke: "#b464be",
    strokeWidth: 2.8188942937117636,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 161.498)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-7.60881s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.95141719940008,
    x2: 157.95141719940008,
    y1: 0,
    y2: -79.29618883972162,
    stroke: "#712be2",
    strokeWidth: 3.5107824741293934,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 1522.22)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-8.5256s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -547.1528529159382,
    x2: -547.1528529159382,
    y1: 0,
    y2: -88.09760562016817,
    stroke: "#b464be",
    strokeWidth: 3.3203966845794133,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2297.83)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-5.95183s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -837.1774339504141,
    x2: -837.1774339504141,
    y1: 0,
    y2: -55.999238535028695,
    stroke: "#b464be",
    strokeWidth: 0.871650754863601,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -989.203)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-6.83352s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -312.5958573214054,
    x2: -312.5958573214054,
    y1: 0,
    y2: -102.31167928357053,
    stroke: "#b464be",
    strokeWidth: 4.593953771293497,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -3565.25)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-0.0979005s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1357.0768424770513,
    x2: -1357.0768424770513,
    y1: 0,
    y2: -43.50168653994996,
    stroke: "#b464be",
    strokeWidth: 2.639727380599135,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2137.77)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-2.11933s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -21.51600036638479,
    x2: -21.51600036638479,
    y1: 0,
    y2: -52.703600095765395,
    stroke: "#b464be",
    strokeWidth: 0.18653108472517888,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2710.9)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-4.32648s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 682.3998264325404,
    x2: 682.3998264325404,
    y1: 0,
    y2: -72.55885652863316,
    stroke: "#b464be",
    strokeWidth: 1.9716267748762117,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2725.13)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-1.32787s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.68322472094646,
    x2: 69.68322472094646,
    y1: 0,
    y2: -58.408418382471474,
    stroke: "#b464be",
    strokeWidth: 1.5829519648970525,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1422.43)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-6.54163s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 738.0455021699698,
    x2: 738.0455021699698,
    y1: 0,
    y2: -58.93989828909623,
    stroke: "#712be2",
    strokeWidth: 2.820300041536065,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 1347.92)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-6.81633s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -481.00468281190723,
    x2: -481.00468281190723,
    y1: 0,
    y2: -97.34510583880126,
    stroke: "#b464be",
    strokeWidth: 1.6667466761782535,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1405.85)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-3.10561s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -906.5663211064488,
    x2: -906.5663211064488,
    y1: 0,
    y2: -32.26412111640728,
    stroke: "#b464be",
    strokeWidth: 4.787871093086763,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 1041.57)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-6.40352s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -459.4394335692553,
    x2: -459.4394335692553,
    y1: 0,
    y2: -74.97113898950366,
    stroke: "#712be2",
    strokeWidth: 1.5005848128846233,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 587.069)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-2.89554s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1102.6479549464957,
    x2: -1102.6479549464957,
    y1: 0,
    y2: -85.76376645587924,
    stroke: "#712be2",
    strokeWidth: 4.994398579088317,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 2924)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-4.47006s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -649.477111844345,
    x2: -649.477111844345,
    y1: 0,
    y2: -60.40062541146555,
    stroke: "#b464be",
    strokeWidth: 1.500060194176066,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1414.05)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-1.54728s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -472.0667554109577,
    x2: -472.0667554109577,
    y1: 0,
    y2: -83.12232851858272,
    stroke: "#b464be",
    strokeWidth: 1.7040197315137429,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 763.631)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-3.0145s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 590.4934293788258,
    x2: 590.4934293788258,
    y1: 0,
    y2: -101.9412061174691,
    stroke: "#b464be",
    strokeWidth: 3.4478181400819983,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1494.67)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-2.98592s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1135.046853996281,
    x2: 1135.046853996281,
    y1: 0,
    y2: -55.69716856489274,
    stroke: "#b464be",
    strokeWidth: 4.743006391747086,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -1189.81)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-1.69836s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.75391111916386,
    x2: 208.75391111916386,
    y1: 0,
    y2: -94.97282468316811,
    stroke: "#712be2",
    strokeWidth: 4.027898018648682,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 864.699)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-6.16519s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -937.7885910459191,
    x2: -937.7885910459191,
    y1: 0,
    y2: -75.28560090121667,
    stroke: "#712be2",
    strokeWidth: 0.30692024822303154,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -157.58)",
      animationPlayState: "running",
      animationDuration: "5s",
      animationDelay: "-7.39383s"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.74573398693585,
    x2: 184.74573398693585,
    y1: 0,
    y2: -33.0307593212595,
    stroke: "#712be2",
    strokeWidth: 4.4539388305695224,
    strokeLinecap: "round",
    className: "ld ld-speed-dash",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, -2546.55)",
      animationPlayState: "running",
      animationDuration: "10s",
      animationDelay: "-1.5685s"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.03569e43f30d28b249f289c03bbceb7d.svg";
export { ForwardRef as ReactComponent };